import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  errorMessage: IErrorMessage | null;
  successMessage: string | null;
  tripsPageFilterOption: string;
  navMenuCollapsed: boolean;
}

export const initialState: UIState = {
  errorMessage: null,
  successMessage: null,
  tripsPageFilterOption: '1',
  navMenuCollapsed: true,
};

export interface IErrorMessage {
  primaryMessage: string;
  secondaryMessage?: string;
}

export const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setErrorMessage: {
      reducer(state: UIState, action: PayloadAction<IErrorMessage>) {
        state.errorMessage = action.payload;
      },
      prepare(primaryMessage: string, secondaryMessage?: string) {
        return {
          payload: {
            primaryMessage,
            secondaryMessage,
          },
        };
      },
    },
    setSuccessMessage: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      state.successMessage = action.payload;
    },
    clearMessages: (state: UIState, action: { type: string }) => {
      state.errorMessage = null;
      state.successMessage = null;
    },
    setTripsPageFilterOption: (
      state: UIState,
      action: { type: string; payload: string },
    ) => {
      state.tripsPageFilterOption = action.payload;
    },
    toggleNavMenu: (state: UIState) => {
      state.navMenuCollapsed = !state.navMenuCollapsed;
    },
    collapseNavMenu: (state: UIState) => {
      state.navMenuCollapsed = true;
    },
  },
});

export const { setErrorMessage } = slice.actions;
export const { setSuccessMessage } = slice.actions;
export const { clearMessages } = slice.actions;
export const { setTripsPageFilterOption } = slice.actions;
export const { toggleNavMenu } = slice.actions;
export const { collapseNavMenu } = slice.actions;

export const selectErrorMessage = (state: { ui: UIState }) =>
  state.ui.errorMessage;

export const selectSuccessMessage = (state: { ui: UIState }) =>
  state.ui.successMessage;

export const selectTripsPageFilterOption = (state: { ui: UIState }) =>
  state.ui.tripsPageFilterOption;

export const selectNavMenuCollapsed = (state: { ui: UIState }) =>
  state.ui.navMenuCollapsed;

export default slice.reducer;
